<template>
  <t-button
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      v-if="loading"
      class="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white m-auto"
    />
    <slot v-else />
  </t-button>
</template>

<script>
import WButton from './WButton';

export default WButton;
</script>

<style lang="scss" scoped>
@import 'WButton';
</style>
